import { SectionMessageType, SectionMessageTypes } from "./SectionMessage";

export function isSectionMessageType(
  value: unknown
): value is SectionMessageType {
  if (typeof value != "string") {
    return false;
  }
  return (SectionMessageTypes as readonly string[]).includes(value);
}

export function parseSectionMessageType(
  value: unknown,
  defaultValue?: SectionMessageType | undefined
) {
  if (!isSectionMessageType(value)) {
    return defaultValue || "default";
  }
  return value;
}
